import { render } from "./MainEmails.vue?vue&type=template&id=693989ba&scoped=true"
import script from "./MainEmails.vue?vue&type=script&lang=js"
export * from "./MainEmails.vue?vue&type=script&lang=js"

import "./MainEmails.vue?vue&type=style&index=0&id=693989ba&scoped=true&lang=css"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-693989ba"]])

export default __exports__